import NavBar from './components/navbar/NavBar';
import PageRoutes from './routes/PageRoutes';

function App() {
  return (
    <div className='font-body'>
      <NavBar />
      <PageRoutes />
    </div>
  );
}

export default App;
